import { SxProps, Theme } from '@mui/material';
import IconSVGTimes from '@/shared/assets/images/icons/icon_times.svg?react';
import { memo, PropsWithChildren } from 'react';

import { StyledDialog } from './StyledDialog';
import { StyledDialogActions } from './StyledDialogActions';
import { StyledDialogTitle, StyledButton, StyledDialogContent } from './styles';
import { inheritDataTestId } from 'ui-kit/lib/utils/dataTestId';
// TODO make it not to affect on scrollbar of the app

export const Dialog = StyledDialog;

interface IDialogTitleProps {
  onClose?: () => void;
  className?: string;
  noContent?: boolean;
  sx?: SxProps<Theme>;
  width?: string;
  // TODO remove it
  closeButtonDataTestId?: string;
}
export const DialogTitle = memo(
  ({
    onClose,
    children,
    className,
    noContent,
    sx,
    width,
    ...restProps
  }: PropsWithChildren<IDialogTitleProps>) => {
    return (
      <StyledDialogTitle className={className} sx={sx}>
        {children}
        {!noContent && (
          <StyledButton
            width={width}
            type="button"
            onClick={onClose}
            data-test-id={inheritDataTestId(restProps, 'close_icon')}
          >
            <IconSVGTimes />
          </StyledButton>
        )}
      </StyledDialogTitle>
    );
  }
);
DialogTitle.displayName = 'DialogTitle';
export const DialogContent = StyledDialogContent;
export const DialogActions = StyledDialogActions;
